import { IRoute } from "src/pages/Router/routes";
import AdminMain from "src/pages/Admin";
import { Icons } from "src/library/components/Icon/types";

import CreateEditPromotionPage from "./CreateEditPromotionPage";
import PromotionsOverviewPage from "./PromotionsOverviewPage";
import CreateEditPromotionalTagPage from "./CreateEditPromotionalTagPage";
import FeaturedProductsPage from "./FeaturedProductsPage";
import ViewAllPromotionalTagsPage from "./ViewAllPromotionalTagsPage";

export const AdminPromotions: IRoute[] = [
  {
    exact: true,
    path: "/admin/promotions",
    pageComponent: PromotionsOverviewPage,
    icon: Icons.PROMOTION,
    title: "Promotional Banners",
    menuTitle: "Promotional Banners",
    menuType: "ADMIN_PROMOTIONS",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "view-promotion" ],
    modules: [ "promotion" ],
    parent: AdminMain[ 0 ]
  },
  {
    exact: true,
    path: "/admin/promotions/create",
    pageComponent: CreateEditPromotionPage,
    title: "Create promotion",
    menuTitle: "Create promotion",
    context: "CREATE_EDIT_PROMOTION",
    menuType: "EMPTY",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "create-promotion" ],
    modules: [ "promotion" ]
  },
  {
    exact: true,
    path: "/admin/promotions/edit/:promotionId",
    pageComponent: CreateEditPromotionPage,
    title: "Edit promotion",
    context: "CREATE_EDIT_PROMOTION",
    menuTitle: "Edit promotion",
    menuType: "EMPTY",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "view-promotion" ],
    modules: [ "promotion" ]
  },
  {
    exact: true,
    path: "/admin/promotions/promotional-tags",
    pageComponent: ViewAllPromotionalTagsPage,
    icon: Icons.LAYERS,
    title: "Promotional tags",
    menuTitle: "Promotional Tags",
    menuType: "ADMIN_PROMOTIONS",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "view-promotion" ],
    modules: [ "promotion" ],
    parent: AdminMain[ 0 ]
  },
  {
    exact: true,
    path: "/admin/promotions/promotional-tags/create",
    pageComponent: CreateEditPromotionalTagPage,
    title: "Create Promotion",
    context: "CREATE_EDIT_PROMOTIONAL_TAG",
    menuTitle: "Create Promotional Tag",
    menuType: "EMPTY",
    privateRoute: true,
    roles: [ "admin" ],
    modules: [ "promotion" ],
    permissions: [ "create-promotion" ]
  },
  {
    exact: true,
    path: "/admin/promotions/promotional-tags/:promotionalTagId",
    pageComponent: CreateEditPromotionalTagPage,
    title: "Edit Promotion",
    context: "CREATE_EDIT_PROMOTIONAL_TAG",
    menuTitle: "Edit Promotional Tag",
    menuType: "EMPTY",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "view-promotion" ],
    modules: [ "promotion" ]
  },
  {
    exact: true,
    path: "/admin/promotions/featured/products",
    pageComponent: FeaturedProductsPage,
    icon: Icons.PRODUCT,
    title: "Featured %PRODUCTS%",
    menuType: "ADMIN_PROMOTIONS",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "view-promotion" ],
    modules: [ "promotion" ],
    parent: AdminMain[ 0 ]
  }
];

export default [ ...AdminPromotions ];
